// extracted by mini-css-extract-plugin
export default {"breadcrumbs_font_weight":"600","breadcrumbs_font_size":"14px","breadcrumbs_line_height":"19px","breadcrumbs_separator_margin":"0 4px"};